import { Widget, type WidgetProps } from "@typeform/embed-react"

const TYPEFORM_DOMAIN = "octopus.typeform.com"

export function Typeform(props: WidgetProps) {
    return (
        <Widget
            domain={TYPEFORM_DOMAIN}
            {...props}
        />
    )
}
